var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("商品管理")]),
              _c("el-breadcrumb-item", [_vm._v("库存调配统计")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.pager.data,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("icTableColumnIndex", {
                attrs: {
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodTitle",
                  align: "center",
                  label: "菜品名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "AdjustTime",
                  align: "center",
                  label: "调配时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyData",
                  align: "center",
                  label: "领货日期",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "oldLevelStock",
                  align: "center",
                  label: "原有库存",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "adjustStock",
                  align: "center",
                  label: "调配数量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "adjustAfterStock",
                  align: "center",
                  label: "调配后库存",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "adjustPlaLogisticsSiteId",
                  align: "center",
                  label: "库存调配方",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receivePlaLogisticsSiteId",
                  align: "center",
                  label: "库存接收方",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "adjustLevelId",
                  align: "center",
                  label: "调配方等级",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveLevelId",
                  align: "center",
                  label: "接受方等级",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }